import { render, staticRenderFns } from "./PrintBtn.vue?vue&type=template&id=6f1aae6e&"
import script from "./PrintBtn.vue?vue&type=script&lang=js&"
export * from "./PrintBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports